import React from "react";
// Components
import CentralMenu from "../components/CentralMenu";
// Styles
import { Wrapper } from "./Home.styles";

const Home = () => {
  return (
    <Wrapper>
      <CentralMenu />
    </Wrapper>
  );
};

export default Home;
